<template>
    <div class="content">
        <section id="wrapper">
            <template v-if="section == 'faq'">
                <Faq />
            </template>
            <template v-else-if="section == 'tos'">
                <Tos />
            </template>
            <!-- <template v-else-if="section == 'privacy' && subpage == 'android'">
                <Privacy />
            </template>
            <template v-else-if="section == 'privacy' && subpage == 'kids'">
                <KidsPrivacy />
            </template> -->
            <template v-else-if="section == 'privacy'"> <!--  && !subpage -->
                <Privacy />
            </template>
            <template v-else-if="section == 'coupon'">
                <Coupon />
            </template>
            <template v-else-if="section == 'download'">
                <Download/>
            </template>
            <template v-else-if="section == 'membership'">
                <Membership />
            </template>
        </section>

    </div>
</template>
<script>
    import Faq from '@/pages/help/Faq.vue'
    import Tos from '@/pages/help/Tos_202310.vue'
    import Privacy from '@/pages/help/Privacy_202312.vue'
    // import PrivacyAndroid from '@/pages/help/PrivacyAndroid.vue'
    // import KidsPrivacy from '@/pages/help/KidsPrivacy_202312.vue'
    import Coupon from '@/pages/coupon/Coupon'
    import Download from '@/pages/download/Download.vue';
    import Membership from '@/pages/membership/Membership'
    export default {
        name: 'pageforchina',
        components: { Faq, Tos, Privacy, Coupon , Download, Membership }, // PrivacyAndroid, KidsPrivacy 
        props: ['section', 'subpage'],
        created(){
            if (this.section == 'intro') {
                // window.location.href = 'https://mp.weixin.qq.com/s/hiAw_UdBTE6VyScmgNfWZA'
                // 'https://mp.weixin.qq.com/s/w0D1auXnn9k74b9M2VkzNw'
                window.location.href = 'https://mp.weixin.qq.com/s/Y3BzinPuIO3PAn1LvZzkNg' 
                
            } else if (this.section == 'coupon') {
                // this.$store.commit('delIds')
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/PageForChina.vue